import React from "react";

export function GlassCard({ children, className = "", ...props }) {
  return (
    <div
      className={`glass rounded-3xl shadow-[0_8px_32px_rgba(0,0,0,0.5)] ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}

export function SectionTitle({ icon: Icon, label, sub, className = "" }) {
  return (
    <div className={`flex items-center gap-2 px-1 mb-3 mt-2 ${className}`}>
      {Icon ? <Icon size={15} className="text-gold" /> : null}
      <span className="text-[11px] font-extrabold tracking-[2px] uppercase text-gold">{label}</span>
      {sub ? <span className="text-[11px] tracking-wide text-muted">· {sub}</span> : null}
    </div>
  );
}

export function GurSetuWordmark({ size = "md" }) {
  const s = size === "sm" ? { ik: 18, name: "text-lg" } : size === "lg" ? { ik: 34, name: "text-3xl" } : { ik: 24, name: "text-2xl" };
  return (
    <div className="flex flex-col items-center leading-none select-none">
      <span className="gold-text font-heading font-bold" style={{ fontSize: s.ik, lineHeight: 1 }}>ੴ</span>
      <span className={`font-heading font-bold gold-text tracking-tight ${s.name}`}>GurSetu</span>
    </div>
  );
}

export function Loader({ label = "Loading…" }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 gap-3" data-testid="loader">
      <div className="w-10 h-10 rounded-full border-2 border-white/10 border-t-[var(--gold)] animate-spin" />
      <span className="text-sm text-muted">{label}</span>
    </div>
  );
}

export function EmptyState({ icon: Icon, title, sub }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-6 text-center gap-2" data-testid="empty-state">
      {Icon ? <Icon size={40} className="text-gold opacity-60 mb-2" /> : null}
      <p className="text-text font-medium">{title}</p>
      {sub ? <p className="text-sm text-muted max-w-sm">{sub}</p> : null}
    </div>
  );
}

export function ErrorState({ message = "Something went wrong.", onRetry }) {
  return (
    <div className="flex flex-col items-center justify-center py-14 px-6 text-center gap-3" data-testid="error-state">
      <p className="text-[var(--danger)] font-medium">{message}</p>
      {onRetry ? (
        <button onClick={onRetry} className="btn-ghost px-5 py-2 text-sm" data-testid="retry-btn">Try again</button>
      ) : null}
    </div>
  );
}

export function Skeleton({ className = "" }) {
  return <div className={`rounded-2xl bg-white/[0.04] animate-pulse ${className}`} />;
}
